import { useMemo } from 'react'
import { targetEnv } from '@fs/zion-config'
import useSiteLink from './useSiteLink'

export default function useForgotLink(forgotPassword = false) {
  const customState = useMemo(() => {
    // have to return back to this page if we are linking, otherwise use normal state URL
    // recovery won't redirect to this page unless URL is to FS hostname with identity/login/link pathname
    // so use that pathname for local dev (acceptance test will have to account for this for testing localhost)
    const href =
      targetEnv === 'local'
        ? window.location.href.replace(/^http:\/\/localhost:[0-9]{4}/, 'https://identint.familysearch.org')
        : window.location.href
    return href.includes('login/link') ? href : undefined
  }, [])
  return useSiteLink({ pathname: '/identity/recovery/find-my-account', forgotPassword, customState })
}
